import { useChains } from "@opensea/app-kit"
import { useMemo } from "react"
import { useChainArch } from "../polychain/hooks/useChainArch"
import { useChainId } from "../polychain/hooks/useChainId"

/**
 * Returns the currently connected/active chain based on wallet state
 */
export function useActiveChain() {
  const { chains } = useChains()
  const activeChainId = useChainId()
  const activeChainArch = useChainArch()

  return useMemo(() => {
    return chains.find(
      c => c.networkId === activeChainId && c.arch === activeChainArch,
    )
  }, [chains, activeChainId, activeChainArch])
}
